/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForActivityLogGcp extends models.GovernanceConfigurationBaseForActivityLog {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForActivityLogGcp");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForActivityLogGcp.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForActivityLogGcp>): GovernanceConfigurationForActivityLogGcp {
        let obj = Object.assign(new GovernanceConfigurationForActivityLogGcp(), model);
        GovernanceConfigurationForActivityLogGcp.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForActivityLogGcp>): GovernanceConfigurationForActivityLogGcp {
        if (!model) return null;
        return GovernanceConfigurationForActivityLogGcp.newInstance(<GovernanceConfigurationForActivityLogGcp> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForActivityLogGcp) {
        if (!obj) return;

        models.GovernanceConfigurationForActivityLogGcp.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForActivityLogGcp): boolean {
        if (models.GovernanceConfigurationBaseForActivityLog.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForActivityLogGcp.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Sink Router Name
     */
    sink_router_name: string;

    /**
     * Topic Name
     */
    topic_name: string;

    /**
     * Subscription Name
     */
    subscription_name: string;

}
